// Thinkt Landing Page - Main Entry Point

// Placeholder for future interactivity
// - Mobile navigation toggle
// - Smooth scroll for anchor links
// - Analytics initialization (privacy-respecting)
// - Widget embed logic

document.addEventListener('DOMContentLoaded', () => {
  // Initialize any interactive components here
  initSmoothScroll()
})

function initSmoothScroll(): void {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const href = (e.currentTarget as HTMLAnchorElement).getAttribute('href')
      if (href && href !== '#') {
        const target = document.querySelector(href)
        if (target) {
          e.preventDefault()
          target.scrollIntoView({ behavior: 'smooth' })
        }
      }
    })
  })
}
